import { render, staticRenderFns } from "./ru.vue?vue&type=template&id=b5e82b8a&scoped=true&"
import script from "./ru.vue?vue&type=script&lang=js&"
export * from "./ru.vue?vue&type=script&lang=js&"
import style0 from "./ru.vue?vue&type=style&index=0&id=b5e82b8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e82b8a",
  null
  
)

export default component.exports